module.exports = "/images/xSocial.png?0e5a8f75806eb22439ec1a2808044ef2";